import styled, { css } from "styled-components";
import ReactTooltip from "react-tooltip";

type Props = {
  isInvestor: boolean;
  disabledDownload?: boolean;
};

export const Container = styled.div`
  width: 90%;
  padding-top: 16px;
  margin: auto;
  max-width: 1221px;
  margin-bottom: 32px;

  .__react_component_tooltip.type-dark.place-top:after {
    border-top-color: ${({ theme }) => theme.colors.tooltipColor.bgColor};
  }
`;

export const Header = styled.div`
  display: flex;
  ${({ theme }) => theme.smartphone} {
    flex-direction: column;
  }

  button {
    width: 156px;
    height: 40px;
    border-radius: 100px;
    font-size: 16px;
    font-weight: 800;
  }
  h1 {
    font-size: 18px;
    font-weight: 800;
    color: ${({ theme }) => theme.riverBed};
    line-height: 25px;
  }
  p {
    font-size: 16px;
    line-height: 22px;
    color: ${({ theme }) => theme.midGray};
  }
`;

export const Search = styled.div`
  margin-top: 19px;
  display: flex;
  justify-content: space-between;

  ${({ theme }) => theme.smartphone} {
    flex-direction: column;
  }

  input {
    font-size: 14px;
    color: ${({ theme }) => theme.silverChalice};
    font-family: Nunito, sans-serif;
    background-color: ${({ theme }) => theme.white};
    font-weight: 400;
    border-radius: 5px;
    border: 0px;
  }
`;

export const SummaryReport = styled.div`
  margin-top: 19px;
  display: flex;
  justify-content: space-between;
  height: 52px;

  padding-left: 20px;
  border-radius: 8px;
  background: url("/assets/images/bg-campaign-card.png"),
    ${({ theme }) => theme.white};
  background-size: 180px;
  background-repeat: no-repeat;
  background-position: -9px 113px;
  ${({ theme }) => theme.smartphone} {
    flex-direction: column;
    height: 125px;
    .tooltip_summary_report {
      display: none;
    }
  }
  .tooltip_summary_report {
    background: #62618b !important;
    border-radius: 8px !important;
    font-family: "Nunito" !important;
    font-style: normal !important;
    font-weight: 600 !important;
    font-size: 13px !important;
    line-height: 16px !important;
    display: flex !important;
    align-items: center !important;
    text-align: center !important;
    color: #ffffff !important;
    padding: 12px !important;
    width: 216px !important;
    height: auto !important;
    @media (max-width: $tablet) {
      left: auto !important;
      right: 28px !important;
    }
  }
  .summary-controls {
    margin-right: 10px;
  }
  input {
    font-size: 14px;
    color: ${({ theme }) => theme.silverChalice};
    font-family: Nunito, sans-serif;
    background-color: ${({ theme }) => theme.white};
    font-weight: 400;
    border-radius: 5px;
    border: 0px;
  }
`;

export const ListNameCompanyWrapper = styled.div<Props>`
  display: flex;
  grid-template-columns: ${({ isInvestor }) =>
    isInvestor ? "20% 80%" : "46px auto"};

  margin-top: 14px;
  margin-bottom: 14px;
  ${({ theme }) => theme.smartphone} {
    margin-left: 10px;
    margin-top: 20px;
    margin-bottom: 10px;
  }
`;

export const Image = styled.img`
  width: 30px;
  height: 30px;
`;

export const Label = styled.div`
  font-family: ${({ theme }) =>
    theme ? theme.font.family.primary : "initial"};
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  color: ${({ theme }) => theme.acentuar};
`;

export const TitleReportSummary = styled.div`
  font-family: Nunito;
  font-size: 18px;
  font-weight: 600;
  line-height: 26.47px;
  text-align: left;
  margin-left: 14px;
  color: #464a60;
  ${({ theme }) => theme.smartphone} {
    width: 250px;
    font-size: 18px;
    margin-left: 20px;
    line-height: 24px;
  }
`;

export const SummaryInfoIcon = styled.div`
  background-image: url('data:image/svg+xml,<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="20" height="20" rx="10" transform="matrix(-1 0 0 1 20.1157 0)" fill="%23475061"/><ellipse cx="10.1156" cy="5.55558" rx="1.66667" ry="1.66667" fill="white"/><rect x="8.44897" y="8.33337" width="3.33333" height="7.77778" rx="1.66667" fill="white"/></svg>');
  background-repeat: no-repeat;
  width: 21px;
  height: 20px;
  float: right;
  margin-left: 20px;
  margin-top: 3px;
  ${({ theme }) => theme.smartphone} {
    display: none;
  }
`;

export const ContainerInput = styled.div`
  > div {
    margin-bottom: 0;
    width: 100%;
  }
  background-color: ${({ theme }) => theme.white};
  width: 605px;
  border-radius: 5px;
  display: flex;
  height: 40px;
  align-items: center;

  ${({ theme }) => theme.smartphone} {
    width: auto;
  }
`;

export const SearchIMG = styled.img`
  width: 18px;
  height: 18px;
  margin-left: 16px;
`;

export const ContainerOptions = styled.div`
  display: flex;

  ${({ theme }) => theme.smartphone} {
    margin-top: 17px;
    justify-content: space-between;
  }

  div:first-child {
    width: 200px;
    margin-right: 17px;
  }
`;

export const ChangeView = styled.button`
  width: 41px;
  height: 41px;
  margin-right: 17px;
  border: 0px;
  border-radius: 4px;
  outline: none;
  cursor: pointer;
  padding: 0;
  background-color: ${({ theme }) => theme.white};
  ${({ theme }) => theme.smartphone} {
    display: none;
  }
  img {
    width: 41px;
    height: 41px;
  }
`;
export const SendEmail = styled.button`
  background-color: ${({ theme }) => theme.cornflowerBlue};
  width: 43px;
  height: 41px;
  border: 0px;
  padding: 0;
  border-radius: 4px;
  outline: none;
  cursor: pointer;
  margin-right: 10px;
  ${({ theme }) => theme.smartphone} {
    margin-right: 0px !important;
  }
  img {
    width: 25px;
    height: 13px;
  }
  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`;

export const SummaryDownloadIcon = styled.button`
  background-color: ${({ theme }) => theme.cornflowerBlue};
  background-image: url('data:image/svg+xml,<svg width="43" height="42" viewBox="0 0 43 42" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="0.5" width="43" height="41" rx="4" fill="%236262F9"/><path d="M22.3265 25.2805C22.218 25.389 22.0891 25.4751 21.9473 25.5339C21.8055 25.5926 21.6535 25.6229 21.5 25.6229C21.3466 25.6229 21.1946 25.5926 21.0528 25.5339C20.911 25.4751 20.7821 25.389 20.6736 25.2805L16.266 20.8729C16.0468 20.6537 15.9237 20.3565 15.9237 20.0465C15.9237 19.7365 16.0468 19.4392 16.266 19.2201C16.4852 19.0009 16.7825 18.8777 17.0924 18.8777C17.4024 18.8777 17.6997 19.0009 17.9189 19.2201L20.3313 21.6325V12.8708C20.3313 12.5608 20.4544 12.2635 20.6736 12.0443C20.8928 11.8252 21.1901 11.702 21.5 11.702C21.81 11.702 22.1073 11.8252 22.3265 12.0443C22.5457 12.2635 22.6688 12.5608 22.6688 12.8708V21.6325L25.0812 19.2201C25.3004 19.0009 25.5977 18.8777 25.9077 18.8777C26.2176 18.8777 26.5149 19.0009 26.7341 19.2201C26.9533 19.4392 27.0764 19.7365 27.0764 20.0465C27.0764 20.3565 26.9533 20.6537 26.7341 20.8729L22.3265 25.2805Z" fill="white"/><path d="M11.3708 17.8312C11.6807 17.8312 11.978 17.9543 12.1972 18.1735C12.4164 18.3927 12.5395 18.69 12.5395 18.9999V27.9603H30.4604V18.9999C30.4604 18.69 30.5835 18.3927 30.8027 18.1735C31.0219 17.9543 31.3191 17.8312 31.6291 17.8312C31.9391 17.8312 32.2363 17.9543 32.4555 18.1735C32.6747 18.3927 32.7979 18.69 32.7979 18.9999V28.3499C32.7979 28.8665 32.5926 29.362 32.2273 29.7273C31.862 30.0926 31.3666 30.2978 30.8499 30.2978H12.1499C11.6333 30.2978 11.1379 30.0926 10.7726 29.7273C10.4072 29.362 10.202 28.8665 10.202 28.3499V18.9999C10.202 18.69 10.3252 18.3927 10.5443 18.1735C10.7635 17.9543 11.0608 17.8312 11.3708 17.8312Z" fill="white"/></svg>');
  width: 43px;
  height: 42px;
  border: 0px;
  float: right;
  border-radius: 4px;
  outline: none;
  margin-right: 15px;
  margin-top: 5px;
  cursor: pointer;

  ${({ theme }) => theme.smartphone} {
    background-image: url('data:image/svg+xml,<svg width="43" height="41" viewBox="0 0 43 41" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.3265 24.7806C22.218 24.8891 22.0891 24.9752 21.9473 25.0339C21.8055 25.0927 21.6535 25.1229 21.5 25.1229C21.3466 25.1229 21.1946 25.0927 21.0528 25.0339C20.911 24.9752 20.7821 24.8891 20.6736 24.7806L16.266 20.373C16.0468 20.1538 15.9237 19.8565 15.9237 19.5465C15.9237 19.2366 16.0468 18.9393 16.266 18.7201C16.4852 18.5009 16.7825 18.3778 17.0924 18.3778C17.4024 18.3778 17.6997 18.5009 17.9189 18.7201L20.3313 21.1326V12.3708C20.3313 12.0609 20.4544 11.7636 20.6736 11.5444C20.8928 11.3252 21.1901 11.2021 21.5 11.2021C21.81 11.2021 22.1073 11.3252 22.3265 11.5444C22.5457 11.7636 22.6688 12.0609 22.6688 12.3708V21.1326L25.0812 18.7201C25.3004 18.5009 25.5977 18.3778 25.9077 18.3778C26.2176 18.3778 26.5149 18.5009 26.7341 18.7201C26.9533 18.9393 27.0764 19.2366 27.0764 19.5465C27.0764 19.8565 26.9533 20.1538 26.7341 20.373L22.3265 24.7806Z" fill="%236262F9"/><path d="M11.3708 17.3313C11.6808 17.3313 11.9781 17.4544 12.1973 17.6736C12.4164 17.8928 12.5396 18.19 12.5396 18.5V27.4604H30.4604V18.5C30.4604 18.19 30.5835 17.8928 30.8027 17.6736C31.0219 17.4544 31.3192 17.3313 31.6292 17.3313C31.9391 17.3313 32.2364 17.4544 32.4556 17.6736C32.6748 17.8928 32.7979 18.19 32.7979 18.5V27.85C32.7979 28.3666 32.5927 28.8621 32.2274 29.2274C31.8621 29.5927 31.3666 29.7979 30.85 29.7979H12.15C11.6334 29.7979 11.1379 29.5927 10.7726 29.2274C10.4073 28.8621 10.2021 28.3666 10.2021 27.85V18.5C10.2021 18.19 10.3252 17.8928 10.5444 17.6736C10.7636 17.4544 11.0609 17.3313 11.3708 17.3313Z" fill="%236262F9"/></svg>');
    background-color: ${({ theme }) => theme.white};
  }
  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`;

export const SendEmailSummary = styled.button`
  background-color: ${({ theme }) => theme.cornflowerBlue};
  background-image: url('data:image/svg+xml,<svg width="43" height="42" viewBox="0 0 43 42" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="0.5" width="43" height="41" rx="4" fill="%236262F9"/><path d="M33.5634 27.4893C33.5728 27.4874 33.582 27.4848 33.5912 27.4824C33.5991 27.4803 33.6071 27.4786 33.6148 27.4761C33.6238 27.4733 33.6327 27.4698 33.6415 27.4666C33.6493 27.4637 33.6572 27.4611 33.6649 27.4577C33.6732 27.4542 33.6812 27.45 33.6893 27.4461C33.6972 27.4422 33.7052 27.4387 33.713 27.4344C33.7207 27.4302 33.728 27.4253 33.7355 27.4207C33.7433 27.416 33.7511 27.4115 33.7586 27.4064C33.7666 27.4009 33.7741 27.3948 33.7818 27.3889C33.7883 27.3839 33.795 27.3792 33.8013 27.3739C33.813 27.364 33.8242 27.3535 33.835 27.3427C33.837 27.3407 33.839 27.3391 33.841 27.3371C33.843 27.335 33.8448 27.3327 33.8467 27.3306C33.8571 27.3196 33.8672 27.3083 33.8768 27.2965C33.8823 27.2895 33.8872 27.2822 33.8924 27.275C33.8977 27.2676 33.9034 27.2604 33.9084 27.2527C33.9137 27.2445 33.9184 27.236 33.9233 27.2275C33.9275 27.2204 33.9319 27.2134 33.9357 27.2061C33.9402 27.1975 33.9439 27.1887 33.9479 27.18C33.9515 27.1723 33.9552 27.1647 33.9585 27.1568C33.9619 27.1482 33.9647 27.1396 33.9677 27.1309C33.9707 27.1224 33.9739 27.114 33.9764 27.1054C33.979 27.0967 33.9809 27.0878 33.983 27.0789C33.9851 27.0701 33.9876 27.0615 33.9893 27.0527C33.9913 27.0423 33.9925 27.0317 33.994 27.0212C33.995 27.0138 33.9963 27.0065 33.9971 26.999C33.9989 26.9805 33.9998 26.962 33.9998 26.9435V15.0561C33.9998 14.7489 33.7571 14.5 33.4577 14.5H16.3793C16.3746 14.5 16.3699 14.5006 16.3652 14.5007C16.3548 14.501 16.3446 14.5015 16.3343 14.5024C16.3261 14.503 16.318 14.504 16.3099 14.5051C16.3007 14.5063 16.2915 14.5077 16.2823 14.5094C16.2737 14.511 16.2652 14.5128 16.2567 14.5148C16.2481 14.5169 16.2395 14.5191 16.231 14.5217C16.2225 14.5241 16.2142 14.5268 16.206 14.5296C16.1975 14.5326 16.1891 14.5357 16.1808 14.5391C16.1729 14.5423 16.1651 14.5455 16.1575 14.5491C16.149 14.553 16.1405 14.5572 16.1321 14.5616C16.125 14.5654 16.1179 14.5693 16.111 14.5733C16.1026 14.5782 16.0944 14.5834 16.0862 14.5888C16.0795 14.5932 16.0729 14.5978 16.0664 14.6025C16.0587 14.608 16.0511 14.6138 16.0437 14.6199C16.0369 14.6255 16.0303 14.6312 16.0237 14.637C16.0172 14.6429 16.0107 14.6488 16.0044 14.655C15.9973 14.662 15.9904 14.6694 15.9836 14.6768C15.9802 14.6805 15.9766 14.6838 15.9734 14.6875C15.9714 14.6898 15.9699 14.6922 15.968 14.6944C15.9612 14.7025 15.9549 14.711 15.9485 14.7195C15.9439 14.7257 15.9391 14.732 15.9348 14.7383C15.9291 14.7466 15.9239 14.7552 15.9187 14.7638C15.9144 14.7708 15.91 14.7778 15.9061 14.785C15.9016 14.7933 15.8976 14.8018 15.8935 14.8103C15.8897 14.8181 15.8858 14.8259 15.8824 14.8338C15.8789 14.8422 15.8758 14.8509 15.8727 14.8594C15.8696 14.8678 15.8664 14.8761 15.8637 14.8846C15.861 14.8931 15.8589 14.9018 15.8565 14.9104C15.8542 14.9193 15.8518 14.9282 15.8498 14.9371C15.848 14.9455 15.8468 14.954 15.8453 14.9625C15.8437 14.9721 15.8422 14.9818 15.841 14.9914C15.8401 14.9994 15.8396 15.0076 15.839 15.0157C15.8383 15.0261 15.8377 15.0365 15.8375 15.047C15.8375 15.05 15.8371 15.053 15.8371 15.056V18.4857C15.8371 18.7929 16.0798 19.0419 16.3793 19.0419C16.6788 19.0419 16.9214 18.7929 16.9214 18.4857V16.2912L21.7417 20.669C21.7166 20.6871 21.6924 20.7072 21.6698 20.7303L16.9214 25.6012V21.9463C16.9214 21.6391 16.6787 21.3902 16.3792 21.3902C16.0797 21.3902 15.837 21.6391 15.837 21.9463V22.6259H13.0358C12.7363 22.6259 12.4937 22.8748 12.4937 23.182C12.4937 23.4892 12.7363 23.7381 13.0358 23.7381H15.837V26.9439C15.837 27.2511 16.0797 27.5 16.3792 27.5H33.4575C33.4754 27.5 33.4932 27.4991 33.511 27.4973C33.5193 27.4965 33.5273 27.4948 33.5355 27.4936C33.5449 27.4923 33.5542 27.4912 33.5634 27.4893ZM32.9154 25.6012L28.1669 20.7303C28.1638 20.7272 28.1606 20.7246 28.1575 20.7217L31.7273 17.6149C31.9556 17.4161 31.9837 17.0653 31.7899 16.831C31.5964 16.5969 31.2543 16.568 31.0258 16.7668L24.9259 22.0754L17.8095 15.6124H32.9154V25.6012ZM22.4367 21.517C22.4753 21.4773 22.5067 21.4331 22.5312 21.3861L24.559 23.2277C24.6615 23.3207 24.7899 23.3675 24.9184 23.3675C25.0432 23.3675 25.1679 23.3235 25.2692 23.2354L27.3358 21.4369C27.3546 21.4651 27.3757 21.492 27.4001 21.517L32.1486 26.3879H17.6882L22.4367 21.517Z" fill="white"/><path d="M9.54217 20.8339H18.6988C18.9983 20.8339 19.241 20.5849 19.241 20.2777C19.241 19.9705 18.9983 19.7216 18.6988 19.7216H9.54217C9.24267 19.7216 9 19.9705 9 20.2777C9 20.5849 9.24267 20.8339 9.54217 20.8339Z" fill="white"/><path d="M10.4909 17.769H14.6023C14.9018 17.769 15.1445 17.5201 15.1445 17.2129C15.1445 16.9057 14.9018 16.6567 14.6023 16.6567H10.4909C10.1914 16.6567 9.94873 16.9057 9.94873 17.2129C9.94873 17.5201 10.1914 17.769 10.4909 17.769Z" fill="white"/><path d="M13.5181 24.9741H9.54217C9.24267 24.9741 9 25.2231 9 25.5303C9 25.8375 9.24267 26.0864 9.54217 26.0864H13.5181C13.8176 26.0864 14.0602 25.8375 14.0602 25.5303C14.0602 25.2231 13.8176 24.9741 13.5181 24.9741Z" fill="white"/></svg>');
  width: 43px;
  height: 42px;
  border: 0px;
  padding: 0;
  margin-top: 5px;
  border-radius: 4px;
  outline: none;
  cursor: pointer;
  float: right;
  img {
    width: 25px;
    height: 13px;
  }
  ${({ theme }) => theme.smartphone} {

    background-image: url('data:image/svg+xml,<svg width="43" height="41" viewBox="0 0 43 41" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M33.8747 26.9893C33.8843 26.9874 33.8937 26.9848 33.9032 26.9824C33.9113 26.9803 33.9194 26.9786 33.9274 26.9761C33.9367 26.9733 33.9457 26.9698 33.9547 26.9666C33.9628 26.9637 33.9708 26.9611 33.9788 26.9577C33.9873 26.9542 33.9955 26.95 34.0038 26.9461C34.0119 26.9422 34.0201 26.9387 34.0281 26.9344C34.036 26.9302 34.0435 26.9253 34.0512 26.9207C34.0592 26.916 34.0672 26.9115 34.0749 26.9064C34.0831 26.9009 34.0907 26.8948 34.0987 26.8889C34.1053 26.8839 34.1122 26.8792 34.1187 26.8739C34.1307 26.864 34.1421 26.8535 34.1533 26.8427C34.1553 26.8407 34.1574 26.8391 34.1594 26.8371C34.1615 26.835 34.1633 26.8327 34.1653 26.8306C34.1759 26.8196 34.1863 26.8083 34.1961 26.7965C34.2018 26.7895 34.2068 26.7822 34.2121 26.775C34.2176 26.7676 34.2234 26.7604 34.2285 26.7527C34.234 26.7445 34.2388 26.736 34.2439 26.7275C34.2481 26.7204 34.2526 26.7134 34.2565 26.7061C34.2611 26.6975 34.265 26.6887 34.2691 26.68C34.2727 26.6723 34.2766 26.6647 34.2799 26.6568C34.2835 26.6482 34.2863 26.6396 34.2894 26.6309C34.2924 26.6224 34.2957 26.614 34.2983 26.6054C34.301 26.5967 34.3029 26.5878 34.3051 26.5789C34.3073 26.5701 34.3098 26.5615 34.3115 26.5527C34.3136 26.5423 34.3148 26.5317 34.3163 26.5212C34.3174 26.5138 34.3188 26.5065 34.3195 26.499C34.3214 26.4805 34.3223 26.462 34.3223 26.4435V14.5561C34.3223 14.2489 34.0734 14 33.7662 14H16.2475C16.2426 14 16.2378 14.0006 16.2329 14.0007C16.2223 14.001 16.2118 14.0015 16.2013 14.0024C16.1929 14.003 16.1846 14.004 16.1763 14.0051C16.1668 14.0063 16.1574 14.0077 16.148 14.0094C16.1391 14.011 16.1304 14.0128 16.1217 14.0148C16.1129 14.0169 16.1041 14.0191 16.0953 14.0217C16.0866 14.0241 16.0781 14.0268 16.0697 14.0296C16.061 14.0326 16.0523 14.0357 16.0438 14.0391C16.0357 14.0423 16.0278 14.0455 16.0199 14.0491C16.0112 14.053 16.0025 14.0572 15.9939 14.0616C15.9865 14.0654 15.9793 14.0693 15.9722 14.0733C15.9636 14.0782 15.9552 14.0834 15.9468 14.0888C15.9399 14.0932 15.9331 14.0978 15.9265 14.1025C15.9186 14.108 15.9108 14.1138 15.9032 14.1199C15.8962 14.1255 15.8894 14.1312 15.8826 14.137C15.876 14.1429 15.8694 14.1488 15.8629 14.155C15.8556 14.162 15.8485 14.1694 15.8416 14.1768C15.8381 14.1805 15.8344 14.1838 15.831 14.1875C15.829 14.1898 15.8275 14.1922 15.8255 14.1944C15.8186 14.2025 15.8121 14.211 15.8055 14.2195C15.8008 14.2257 15.7959 14.232 15.7914 14.2383C15.7857 14.2466 15.7803 14.2552 15.775 14.2638C15.7706 14.2708 15.7661 14.2778 15.7621 14.285C15.7574 14.2933 15.7533 14.3018 15.7491 14.3103C15.7452 14.3181 15.7412 14.3259 15.7378 14.3338C15.7341 14.3422 15.7309 14.3509 15.7277 14.3594C15.7246 14.3678 15.7213 14.3761 15.7185 14.3846C15.7158 14.3931 15.7136 14.4018 15.7112 14.4104C15.7088 14.4193 15.7063 14.4282 15.7043 14.4371C15.7025 14.4455 15.7012 14.454 15.6997 14.4625C15.6981 14.4721 15.6964 14.4818 15.6953 14.4914C15.6943 14.4994 15.6939 14.5076 15.6933 14.5157C15.6925 14.5261 15.6918 14.5365 15.6917 14.547C15.6916 14.55 15.6913 14.553 15.6913 14.556V17.9857C15.6913 18.2929 15.9402 18.5419 16.2474 18.5419C16.5546 18.5419 16.8036 18.2929 16.8036 17.9857V15.7912L21.7482 20.169C21.7224 20.1871 21.6975 20.2072 21.6744 20.2303L16.8035 25.1012V21.4463C16.8035 21.1391 16.5545 20.8902 16.2473 20.8902C15.9401 20.8902 15.6912 21.1391 15.6912 21.4463V22.1259H12.8177C12.5105 22.1259 12.2616 22.3748 12.2616 22.682C12.2616 22.9892 12.5105 23.2381 12.8177 23.2381H15.6912V26.4439C15.6912 26.7511 15.9401 27 16.2473 27H33.766C33.7843 27 33.8027 26.9991 33.8209 26.9973C33.8294 26.9965 33.8377 26.9948 33.846 26.9936C33.8557 26.9923 33.8652 26.9912 33.8747 26.9893ZM33.2099 25.1012L28.339 20.2303C28.3359 20.2272 28.3325 20.2246 28.3293 20.2217L31.9912 17.1149C32.2254 16.9161 32.2542 16.5653 32.0555 16.331C31.8569 16.0969 31.506 16.068 31.2716 16.2668L25.0145 21.5754L17.7145 15.1124H33.2099V25.1012ZM22.461 21.017C22.5007 20.9773 22.5329 20.9331 22.558 20.8861L24.6381 22.7277C24.7432 22.8207 24.8749 22.8675 25.0068 22.8675C25.1347 22.8675 25.2627 22.8235 25.3666 22.7354L27.4864 20.9369C27.5057 20.9651 27.5274 20.992 27.5524 21.017L32.4233 25.8879H17.5901L22.461 21.017Z" fill="%236262F9"/><path d="M9.23382 20.3339H18.6266C18.9338 20.3339 19.1827 20.0849 19.1827 19.7777C19.1827 19.4705 18.9338 19.2216 18.6266 19.2216H9.23382C8.92661 19.2216 8.67767 19.4705 8.67767 19.7777C8.67767 20.0849 8.92661 20.3339 9.23382 20.3339Z" fill="%236262F9"/><path d="M10.2072 17.2691H14.4246C14.7318 17.2691 14.9808 17.0201 14.9808 16.7129C14.9808 16.4057 14.7318 16.1568 14.4246 16.1568H10.2072C9.89993 16.1568 9.651 16.4057 9.651 16.7129C9.651 17.0201 9.89993 17.2691 10.2072 17.2691Z" fill="%236262F9"/><path d="M13.3122 24.4742H9.23382C8.92661 24.4742 8.67767 24.7231 8.67767 25.0303C8.67767 25.3375 8.92661 25.5864 9.23382 25.5864H13.3122C13.6195 25.5864 13.8684 25.3375 13.8684 25.0303C13.8684 24.7231 13.6195 24.4742 13.3122 24.4742Z" fill="%236262F9"/></svg>');
    background-color: ${({ theme }) => theme.white};
    img {
      display: none;
    }
  }
  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`;

export const ButtonsIMG = styled.img``;

export const ImageEmpty = styled.img`
  width: 182px;
`;

export const ContainerEmpty = styled.div`
  width: 100%;
  height: 60vh;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  ${({ theme }) => theme.smartphone} {
    height: 40vh;
  }

  p {
    font-size: 16px;
    line-height: 22px;
    color: ${({ theme }) => theme.mako};
    width: 296px;
    text-align: center;
    margin-top: 10px;
  }
`;

export const Tooltip = styled(ReactTooltip)`
  ${({ theme }) => css`
    background: ${theme.colors.tooltipColor.bgColor} !important;
    color: ${theme.white};
  `}
`;
